import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import HRApp from "./HRApp";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import theme from "./theme/chakraTheme";
import { watchColorMode } from "./theme/colorMode";

watchColorMode();

// HR mode runs on light backgrounds (matches WP plugin screenshots). Force
// light color-mode at boot so we never inherit a stale "dark" value from
// localStorage that may have been set previously.
if ((process.env.REACT_APP_MODE || "hr").toLowerCase() === "hr") {
  document.documentElement.classList.add("hr-mode");
  try {
    localStorage.setItem("chakra-ui-color-mode", "light");
    document.documentElement.dataset.theme = "light";
  } catch (e) { /* noop */ }
}

// Build-mode switch — picked at CRA build time via REACT_APP_MODE.
// Defaults to "hr" (this is the HR app). The legacy `App` root is kept as a
// fallback only because some shared shell components still import it.
const MODE = (process.env.REACT_APP_MODE || "hr").toLowerCase();
const RootApp = MODE === "hr" ? HRApp : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider theme={theme}>
        <RootApp />
      </ChakraProvider>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
